var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetabotShades = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 58,
  height: 43,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-secondary)",
  d: "M54 .75H4A3.25 3.25 0 0 0 .75 4v35A3.25 3.25 0 0 0 4 42.25h50A3.25 3.25 0 0 0 57.25 39V4A3.25 3.25 0 0 0 54 .75Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-primary)",
  fillRule: "evenodd",
  d: "M4 1.5A2.5 2.5 0 0 0 1.5 4v35A2.5 2.5 0 0 0 4 41.5h50a2.5 2.5 0 0 0 2.5-2.5V4A2.5 2.5 0 0 0 54 1.5H4ZM0 4a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4v35a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-background)",
  d: "M49 6H9a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h40a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-primary)",
  fillRule: "evenodd",
  d: "M9 6.75c-.69 0-1.25.56-1.25 1.25v22c0 .69.56 1.25 1.25 1.25h40c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25H9ZM6.25 8A2.75 2.75 0 0 1 9 5.25h40A2.75 2.75 0 0 1 51.75 8v22A2.75 2.75 0 0 1 49 32.75H9A2.75 2.75 0 0 1 6.25 30V8Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-primary)",
  d: "M31 20.5h1c0 1.77-1.048 3-3 3s-3-1.23-3-3h1c0 1 .5 2 2 2s2-1 2-2ZM20.75 17.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5ZM36.75 17.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-secondary)",
  stroke: "var(--illustration-primary)",
  d: "M43.5 38.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM49 38.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#metabot-shades_svg__a)",
  stroke: "#fff",
  d: "M28 8.538c0 3.035-1.567 7.177-4.299 10.568-2.726 3.384-6.54 5.932-10.974 5.932-3.41 0-5.943-1.048-7.63-2.9-1.694-1.86-2.597-4.6-2.597-8.1 0-3.26 1.15-5.87 3.131-7.668C7.62 4.567 10.49 3.538 14 3.538c.17 0 .405-.006.696-.012 1.496-.036 4.44-.105 7.22.373 1.659.286 3.203.76 4.32 1.514C27.33 6.154 28 7.15 28 8.538Zm17.273 16.5c-4.435 0-8.248-2.547-10.975-5.932C31.567 15.716 30 11.573 30 8.538c0-1.389.669-2.384 1.764-3.125 1.117-.755 2.661-1.228 4.32-1.514 2.78-.478 5.724-.409 7.22-.373.29.006.527.012.696.012 3.51 0 6.381 1.029 8.369 2.832C54.35 8.17 55.5 10.778 55.5 14.038c0 3.5-.903 6.24-2.597 8.1-1.687 1.852-4.22 2.9-7.63 2.9Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M30 9h-2.5V8H30v1ZM17.5 3a.5.5 0 0 1 .5-.5h22a.5.5 0 0 1 0 1H18a.5.5 0 0 1-.5-.5Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--illustration-background)",
  d: "M55 11h3v2h-3v-2ZM0 11h3v2H0v-2Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "metabot-shades_svg__a",
  x1: 42.75,
  x2: 42.75,
  y1: 3,
  y2: 25.538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--illustration-primary)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--illustration-secondary)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetabotShades);
export default ForwardRef;